// extracted by mini-css-extract-plugin
module.exports = {"blockSection":"styles_blockSection__uQ755"};